import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import PopUp from "./PopUp";
import InputText from "./form-input-inline";
import { validateNewPassword, PASSWORD_RULE_MESSAGE } from "../../../../../passwordRules";
import { changePassword } from "../../../../../jsx/actions/authAction";

// Fenêtre de changement de mot de passe (POST /login/change/pwd, session passport en cours).
// Si currentPassword est fourni (connexion avec mot de passe temporaire), il n'est pas redemandé.
// En cas de succès le serveur détruit la session : l'appelant décide de la suite via onSuccess(nouveauMotDePasse).
const ChangePasswordDialog = ({ currentPassword, title, intro, cancelTitle, onCancel, onSuccess }) => {
	const askCurrent = currentPassword === undefined;
	const [oldPwd, setOldPwd] = useState("");
	const [newPwd, setNewPwd] = useState("");
	const [confirmPwd, setConfirmPwd] = useState("");
	const [error, setError] = useState("");
	const [busy, setBusy] = useState(false);

	const submit = async () => {
		const old = askCurrent ? oldPwd : currentPassword;
		const invalid = validateNewPassword({ current: old, next: newPwd, confirm: confirmPwd });
		if (invalid) {
			setError(invalid);
			return;
		}
		setError("");
		setBusy(true);
		const resp = await changePassword({ old: old, toNew: newPwd, toNewConfirm: confirmPwd });
		setBusy(false);
		if (resp.ok) {
			onSuccess(newPwd);
			return;
		}
		setError(resp.error);
	};

	return (
		<PopUp
			maxWidth="sm"
			title={title || "Changer mon mot de passe"}
			close={onCancel}
			submitAction={submit}
			submitTitle="Valider"
			cancelTitle={cancelTitle || "Annuler"}
			disabledSubmit={busy}
		>
			<Box>
				{intro && (
					<Box p={1}>
						<Typography variant="body1">{intro}</Typography>
					</Box>
				)}
				{askCurrent && (
					<InputText
						required
						type="password"
						name="currentPassword"
						value={oldPwd}
						label="Mot de passe actuel"
						onChange={(e) => setOldPwd(e.target.value)}
					/>
				)}
				<InputText
					required
					type="password"
					name="newPassword"
					value={newPwd}
					label="Nouveau mot de passe"
					helperText={PASSWORD_RULE_MESSAGE}
					onChange={(e) => setNewPwd(e.target.value)}
				/>
				<InputText
					required
					type="password"
					name="confirmPassword"
					value={confirmPwd}
					label="Confirmation du nouveau mot de passe"
					onChange={(e) => setConfirmPwd(e.target.value)}
				/>
				{error && (
					<Box p={1}>
						<Typography color="error">{error}</Typography>
					</Box>
				)}
			</Box>
		</PopUp>
	);
};

export default ChangePasswordDialog;
